import { useSnackbar } from 'notistack'
import React, { memo, useCallback } from 'react'
import { connect } from 'react-redux'

import { fumigar } from '../../../../../../../../models/movimiento/movimientoService'
import { closeDialog } from '../../../../../../../Forms/SharedComponents/containers/Dialog/actions/dialogActions'
import { actualizarEstadoSilos } from '../../../../../../actions'
import { OperacionNuevoFumigadoView } from '../components/OperacionNuevoFumigadoView'

export const OperacionNuevoFumigado = connect(null, { closeDialog, actualizarEstadoSilos })(
  memo(({ silo, closeDialog, actualizarEstadoSilos }) => {
    const { enqueueSnackbar } = useSnackbar()
    return (
      <OperacionNuevoFumigadoView
        silo={silo}
        aceptar={async ({ producto, observaciones }) => {
          try {
            await fumigar(silo, producto, observaciones)
            closeDialog()
            enqueueSnackbar('Fumigado correcto')
            actualizarEstadoSilos()
          } catch (error) {
            enqueueSnackbar('Fumigado incorrencto', { variant: 'error' })
          }
        }}
        cancelar={useCallback(() => {
          closeDialog('FUMIGADO_SILO')
        }, [closeDialog])}
      />
    )
  })
)
